import { Component, Input } from "@angular/core";

@Component({
    selector: "upsell-banner",
    templateUrl: "upsell-banner.html",
    styleUrls: ["upsell-banner.scss"],
    standalone: false
})

export class UpsellBannerComponent {

  @Input() bannerText: string = '';
  @Input() bannerImage: string = 'https://cdn.lonewolfranchpets.com/images/legacy-badge.webp';

  constructor() {}
}
